<template>
  <div class="package-box" :class="size" @click="click">
    <div class="flex">
      <div class="img-warp" :class="{ odd: finallyData.length % 2 !== 0 }">
        <div class="img-box" v-for="item in finallyData" :key="item.id">
          <img :src="item.finallyImg" />
        </div>
      </div>
      <div class="right-box flex" v-if="size == 'normal'">
        <div class="top">
          <div class="name ellipsis">{{ data.data.name }}</div>
          <div class="product-name">
            <p v-for="item in finallyData" :key="'name' + item.id" class="ellipsis">{{ item.productName }}</p>
          </div>
        </div>
        <div class="buttom">
          <div class="oprice">
            <formatMoney :value="data.data.originTotalAmount" :isHide="appStores.isHideMoney" />
          </div>
          <p>套餐价</p>
          <div class="price">
            <formatMoney :value="data.data.totalAmount" :isHide="appStores.isHideMoney" />
          </div>
        </div>
      </div>
      <div class="bottom-name ellipsis" v-if="size == 'small'">
        {{ data.data.name }}
      </div>
    </div>

    <div class="big-name" v-if="size == 'big'">
      <div class="title ellipsis">{{ data.data.name }}</div>
      <div class="flex">
        <div class="oprice2">
          <p>套餐价</p>
          <div class="price">
            <formatMoney :value="data.data.totalAmount" :isHide="appStores.isHideMoney" />
          </div>
        </div>
        <div class="oprice">
          <formatMoney :value="data.data.originTotalAmount" :isHide="appStores.isHideMoney" />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { generateImageFromText } from '@/utils/defaultImageGenerator';
import { appInfo } from '@/stores/appInfo';
const appStores = appInfo();
const data = defineProps({
  // 套餐数据
  data: {
    type: Object,
    default: () => {},
  },
  // 展示大小
  size: {
    type: String,
    default: 'normal',
  },
});
const finallyData = ref([]);
const emits = defineEmits(['packageClick']);
watch(
  () => data.data,
  val => {
    if (val) {
      console.log(val);
      format();
    }
  },
  { immediate: true }
);
async function format() {
  for (let index = 0; index < data.data.packageItems.length; index++) {
    let chache = data.data.packageItems[index];
    console.log(chache);
    if (chache.productPic) {
      chache.finallyImg = chache.productPic;
    } else {
      chache.finallyImg = await generateImageFromText(chache.productName);
    }
    if (finallyData.value.length < 4) {
      finallyData.value.push(chache);
    }
  }
}
function click() {
  emits('packageClick');
  useRouter().push(`/packages/${data.data.id}${data.data.zoneId ? `?zoneId=${data.data.zoneId}` : ''}`);
}
</script>

<style lang="scss" scoped>
.package-box {
  background-color: #fff;
  border-radius: 6px;
  padding: 12px;
  box-sizing: border-box;
  height: 260px;

  position: relative;
  cursor: pointer;

  &:hover {
    .name,
    .bottom-name {
      color: $main-color;
    }
    .big-name {
      .title {
        color: $main-color;
      }
    }
  }

  .flex {
    align-items: stretch;

    .img-warp {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 8px;
      background-color: $main-backgroud-color;
      padding: 12px;
      border-radius: 6px;
      align-items: center;
      flex-shrink: 0;

      .img-box {
        img {
          border-radius: 6px;
          overflow: hidden;
          width: 102px;
          margin: 0 auto;
          display: block;
        }
      }
    }

    .odd {
      .img-box:first-child {
        grid-column: span 2;
      }
    }

    .right-box {
      flex-direction: column;
      width: 182px;
      margin-left: 12px;
      flex-grow: 1;

      .top,
      .buttom {
        width: 100%;
      }

      .top {
        .name {
          font-size: 16px;
          margin-bottom: 12px;
        }

        .product-name {
          border-radius: 6px;
          background-color: $main-backgroud-color;
          padding: 9px;

          p {
            font-size: 14px;
            color: #606266;
            line-height: 1.5;
          }
        }
      }

      .buttom {
        text-align: right;

        .oprice {
          text-decoration: line-through;
          color: #909399;
          font-size: 16px;
        }

        p {
          font-size: 14px;
          margin: 8px 0 6px;
        }

        .price {
          font-size: 18px;
          font-weight: bold;
          color: #f56c6c;
        }
      }
    }

    .bottom-name {
      position: absolute;
      left: 0;
      bottom: 0;
      width: calc(100% - 24px);
      padding: 12px;
      padding-top: 34px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 51%);
      border-radius: 0 0 6px 6px;
    }
  }
}

.normal,
.small {
  .img-warp {
    box-sizing: border-box;
    width: 236px;
    height: 236px;
  }
}

.big {
  height: auto;
  padding: 16px;
  box-sizing: border-box;

  .img-warp {
    width: 196px;
    height: 196px;
  }

  .big-name {
    margin-top: 16px;
    .flex {
      align-items: end;
      justify-content: flex-start;
    }
    .oprice {
      text-decoration: line-through;
      color: #909399;
      font-size: 16px;
      margin-left: 16px;
    }

    p {
      font-size: 14px;
      margin: 8px 0 6px;
    }

    .price {
      font-size: 20px;
      font-weight: bold;
      color: #f56c6c;
    }
  }
}

.ellipsis {
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏溢出的文本 */
  text-overflow: ellipsis;
  /* 显示省略号 */
}
</style>
